import { Box, Skeleton, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type SolarCardStatus =
  | 'loading'
  | 'error'
  | 'ready'
  | 'no-site'
  | 'no-solar'
  | 'no-tariffs';

const MESSAGES: Record<
  Exclude<SolarCardStatus, 'ready' | 'loading'>,
  string
> = {
  error: "Could not load the site's solar performance.",
  'no-site': 'Select a site to see its solar performance.',
  'no-solar': 'This site has no electricity meter points tagged solar.',
  'no-tariffs':
    'Savings need one municipal meter point with a reference tariff and a solar utility with a PPA tariff.',
};

interface Props {
  status: SolarCardStatus;

  children: ReactNode;
}

/** Renders its children when the solar data is ready, a skeleton while it loads, and a message for each other status. */
const SolarCardState = ({ status, children }: Props) => {
  if (status === 'ready') return <>{children}</>;

  if (status === 'loading') {
    return (
      <Skeleton
        variant='rectangular'
        sx={{ flex: 1, minHeight: 80, borderRadius: 1 }}
      />
    );
  }

  return (
    <Box
      flex={1}
      display='flex'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
      px={2}
    >
      <Typography variant='body2' color='text.secondary'>
        {MESSAGES[status]}
      </Typography>
    </Box>
  );
};

export default SolarCardState;
